import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";
import Logo from "../assets/images/logo.png";
import UserService from "../services/UserService";
import firebase from "../services/FirebaseService";

import "../assets/style/navbar.css";

const Navbar = () => {

	const [ opened, setOpened ] = useState(false); 
	
	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async user => {
		
			if(user) {
				const isAdmin = await userService.isUserAdmin(user.uid);
	
				isAdmin ? setPriviledged(1) : setPriviledged(2);
	
			}
			else {
				setPriviledged(2);
			}
	
		});
	});

	return (
		<>
			<nav>
				<div id="bars">
					<button onClick={() => setOpened(!opened)}><FontAwesomeIcon icon={faBars} /></button>
				</div>
				<div id="logo">
					<Link to="/"><img src={Logo} alt="No Fap Guidance" /></Link>
				</div>
				<ul className={opened ? "opened" : ""}>
					<li><Link to="/blog">Blog</Link></li>
					<li><Link to="/pricing">Pricing</Link></li>
					<li><Link to="/support">Support</Link></li>
					<li><Link to="/new-request">Request</Link></li>
					<li><Link to="/donate-a-program">Donate</Link></li>
					{ privileged === 1 && <li><Link to="/admin">Admin</Link></li> }
				</ul>
				<div id="profile">
					<AuthProvider>
						<IfFirebaseUnAuthed>
							<Link to="/auth/login"><img alt="profile" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.istockphoto.com%2Fvectors%2Fprofile-placeholder-image-gray-silhouette-no-photo-vector-id1016744004%3Fk%3D6%26m%3D1016744004%26s%3D170667a%26w%3D0%26h%3DdsibM8vNYIJDN1wtB8SWex8M99vl6a9NoDsobZ9dUCo%3D&f=1&nofb=1" /></Link>
						</IfFirebaseUnAuthed>
						<IfFirebaseAuthed>
							<Link to="/profile"><img alt="profile" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.istockphoto.com%2Fvectors%2Fprofile-placeholder-image-gray-silhouette-no-photo-vector-id1016744004%3Fk%3D6%26m%3D1016744004%26s%3D170667a%26w%3D0%26h%3DdsibM8vNYIJDN1wtB8SWex8M99vl6a9NoDsobZ9dUCo%3D&f=1&nofb=1" /></Link>
						</IfFirebaseAuthed>
					</AuthProvider>
				</div>
			</nav>
			<div id="nav-helper"></div>
		</>
	)
};

export default Navbar;